import './VeryTop.css';
import { Link } from 'react-router-dom';
import { isPostWedding, isToday } from '../after';
import { Icon } from './RSVP';

import arrow from '../img/svg/arrow-right-svgrepo-com.svg';
import { useI18n } from '../i18n/i18n';

export function VeryTop() {
    const t = useI18n();
    return <section id="top" className="very-top">
        {!isPostWedding() && <div className="when">
            <div className="top-text">{t.veryTop.wgm}</div>
            <span>2025</span>
            <span>05</span>
            <span>31</span>
        </div>}
        <div className="bold gold">-</div>
        {!isPostWedding() && <div>
            <Link className="cta-link google-form-link" to="/rsvp">
                <span>{isToday() ? t.veryTop.rsvpToday : t.veryTop.rsvp}</span>
                <Icon src={arrow} alt="Google Forms" classNames={['small']} />
            </Link>
        </div>}
        <div className="frames desktop">
            <div className="right-img gradient g2  card" />
            <div className="main-img gradient card" />
            <div className="left-img gradient g1 card" />
        </div>
        <div className="frames mobile">
            <div />
            <div className="main-img gradient card" />
            <div />
        </div>
    </section>
}
